import { render, staticRenderFns } from "./confirmSecretCode.popup-chunk.vue?vue&type=template&id=e0ccb52a&scoped=true"
import script from "./confirmSecretCode.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmSecretCode.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ccb52a",
  null
  
)

export default component.exports